export default "__VITE_ASSET__DdgeY7h___"